import { HospitalInfoEntity } from "@/domain/entity/hospital-info-entity";
import { HospitalRepository } from "@/domain/repository/hospital-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class FetchHospitalUsecase {
  constructor(private readonly hospitalRepo: HospitalRepository) {}

  async execute(hospitalCode: string): Promise<SATResult<HospitalInfoEntity, SATError>> {
    return this.hospitalRepo.getHospitalInfo({ hospitalCode });
  }
}
